module.exports = __webpack_public_path__ + "img/amanda-miller.04924d73.png";